export const prefetchSourceSet = srcSet => {
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.as = 'image';
  link.href = srcSet[0];
  link.crossOrigin = 'anonymous';
  link.imageSrcset = srcSet.map((src, index) => `${src} ${400 * (index + 1)}w`).join(', ');
  document.head.appendChild(link);
};